<template>
  <div class="igi">
    <image-ext
      v-model="imageAssets"
      :src="fullImagePath"
      :limit-height="200"
      :thumb-x="30"
      :thumb-y="30"
    />

    <div class="igi__controls">
      <div class="drag-handle">
        <v-icon color="white">mdi-drag</v-icon>
      </div>
      <v-icon color="white" @click="onCloseClick">
        mdi-close
      </v-icon>
    </div>
  </div>
</template>

<script>
import ImageExt from "@/components/ImageExt.vue";

export default {
  components: {
    ImageExt
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imageAssets: {
      get() {
        const contain = this.value ? this.value.i_contain || "0" : "0";
        const defBackground = this.$store.getters.getDefaultBackground;
        const fill = this.value
          ? this.value.i_fill || defBackground
          : defBackground;
        const left = this.value?.i_left || null;
        const top = this.value?.i_top || null;
        const right = this.value?.i_right || null;
        const bottom = this.value?.i_bottom || null;
        return { contain, fill, left, top, right, bottom };
      },
      set(val) {
        const data = {
          i_main: this.value.i_main,
          i_contain: val.contain,
          i_fill: val.fill,
          i_left: val.left,
          i_top: val.top,
          i_right: val.right,
          i_bottom: val.bottom
        };
        this.$emit("input", data);
      }
    },
    fullImagePath() {
      return (this.value?.i_main || "").replace(
        "<STORAGE>",
        this.$store.getters.getStoragePrefix
      );
    }
  },
  methods: {
    onCloseClick() {
      this.$emit("on-close-click");
    }
  }
};
</script>

<style lang="scss" scoped>
.igi {
  background: #fff;
  border: 1px solid #888;
  margin: 8px;
  position: relative;
  flex-grow: 0;
  max-width: 300px;

  .igi__controls {
    position: absolute;
    right: 0;
    top: 0;
    background-color: rgba(100, 100, 100, 0.5);
    display: none;
  }

  &:hover {
    .igi__controls {
      display: flex;
    }
  }

  &::v-deep .iext__image {
    max-width: 100%;
    height: auto;
  }
}
</style>
